document.addEventListener('DOMContentLoaded', () => {
    const toggles = document.querySelectorAll('.accordion__toggle');

    toggles.forEach(toggle => {
        const contentId = toggle.getAttribute('aria-controls');
        const content = document.getElementById(contentId);

        toggle.addEventListener('click', () => {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!isExpanded));

            if (!isExpanded) {
                // Opening
                content.hidden = false;
                content.classList.add('accordion__content--open');
                content.style.maxHeight = content.scrollHeight + 'px';

                // Allow transition to complete, then remove max-height so it can grow naturally
                content.addEventListener('transitionend', function handler(e) {
                    if (e.propertyName === 'max-height') {
                        content.style.maxHeight = 'none';
                        content.removeEventListener('transitionend', handler);
                    }
                });
            } else {
                // Closing
                // Set back maxHeight so we can animate it to 0
                content.style.maxHeight = content.scrollHeight + 'px';

                // Allow reflow
                requestAnimationFrame(() => {
                    content.style.maxHeight = '0';
                    content.classList.remove('accordion__content--open');
                });

                // After transition, set hidden = true
                content.addEventListener('transitionend', function handler(e) {
                    if (e.propertyName === 'max-height') {
                        content.hidden = true;
                        content.style.maxHeight = ''; // Clean up inline style
                        content.removeEventListener('transitionend', handler);
                    }
                });
            }
        });
    });
});